var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 414.339 414.339",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M408.265,162.615L230.506,58.601c-3.795-2.222-8.485-2.241-12.304-0.057c-3.815,2.187-6.17,6.246-6.174,10.644 l-0.036,46.966c-0.213,0.052-0.38,0.094-0.495,0.126c-4.442,1.239-9.163,2.603-14.854,4.294 c-18.457,5.483-37.417,12.593-59.668,22.374c-19.309,8.487-38.201,19.442-56.15,32.559c-12.826,9.373-24.894,20.182-35.867,32.126 C15.1,240.129-1.259,283.28,0.076,326.023c0.234,7.488,1.076,14.674,1.869,20.716c0.788,6.007,5.84,10.541,11.898,10.677 c0.093,0.002,0.186,0.003,0.277,0.003c5.94,0,11.048-4.263,12.086-10.139c3.304-18.678,8.574-34.022,16.111-46.91 c9.42-16.104,22.223-29.625,37.021-39.102c12.718-8.146,26.153-14.396,41.075-19.113c17.405-5.503,36.597-8.952,58.671-10.545 c8.907-0.644,18.502-0.967,30.2-1.021c0.354,0,1.112,0.007,2.098,0.02l0.032,44.29c0.003,4.372,2.332,8.413,6.113,10.607 c3.782,2.196,8.446,2.214,12.245,0.049l178.37-101.678c3.811-2.172,6.172-6.21,6.196-10.597 C414.366,168.896,412.05,164.831,408.265,162.615z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowSvgrepoCom);
export default __webpack_public_path__ + "static/media/right-arrow-svgrepo-com.753dfd17592715f40c4d561fab411679.svg";
export { ForwardRef as ReactComponent };